export const PORTAL_TITLE = "Capital One Travel Portal";
export const SEARCH_HOTEL_TITLE = "Search a hotel";
export const SELECT_HOTEL_TITLE = "Select a hotel";
export const SELECT_ROOM_TITLE = "Select a room";
export const HOTEL_CHECKOUT_TITLE = "Complete Hotel Booking";
export const HOTEL_CONFIRMATION_TITLE = "Booking Confirmation";

export const SORT_RECOMMENDED = "Recommended";
export const SORT_PRICE_LOW_TO_HIGH = "Price (Low to High)";
export const SORT_PRICE_HIGH_TO_LOW = "Price (High to Low)";
